import React from 'react';
import FormSelectField from '../../../../components/form/select-field';
import FormError from '../../../../components/form/error/error';
import { setDropDownValue } from '../../../ssm-homepage/ssm-homepage.actions';

const SipCallingTrunksNumber = (props) => {
  const {
    siteId,
    sitesSipConnectNumberOfTrunks,
    handleSipConnectCallingPlanNumberOfTrunks,
    numberOfTrunksLabel,
    optionPlaceholder,
    trunkOptions,
    errorText,
    showError,
  } = props;

  return (
    <div className="col-md-12">
      <div className="row">
        <div className="col-md-4 col-sm-12 table-heading">
          {numberOfTrunksLabel}
        </div>
        <div className="col-md-8 col-sm-12 padding-text text-center">
          { (typeof trunkOptions !== 'string') ?
            <FormSelectField
              id={siteId}
              label=""
              options={trunkOptions}
              value={sitesSipConnectNumberOfTrunks[siteId] !== undefined ?
                setDropDownValue(trunkOptions, sitesSipConnectNumberOfTrunks[siteId].toString()) : setDropDownValue(trunkOptions, optionPlaceholder)}
              onBlur={handleSipConnectCallingPlanNumberOfTrunks}
              placeholder={optionPlaceholder}
              showScrollBar
              sendKeyValueOnChange
              initialValuePresent
            />
            :
            <b>{trunkOptions}</b>
          }
          {showError === true &&
            <FormError errorText={errorText} />
          }
        </div>
      </div>
    </div>
  );
};

export default SipCallingTrunksNumber;
